/**
 * ポータル API（/api/portal/*。担当: G4）
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface PortalSummaryDto {
  planDays: number;
  actualDays: number;
  rate: number;
}

export type PortalArea = '全域' | '尖閣諸島周辺';

export interface DailyVesselDto {
  noticeVesselId: number;
  noticeId: number;
  noticeNo: string;
  businessOperatorId: number | null;
  businessOperatorName: string;
  vesselId: number | null;
  vesselName: string;
  nameKana: string;
  ownerName: string;
  captainName: string;
  registrationNo: string;
  tonnage: number | null;
  crewCount: number;
  phone: string;
  totalBoardingCount: number | null;
  departureDate: string;
  arrivalDate: string;
  zoneNumbers: string;
  catchSurveyPlanned: boolean;
  catchSalePlanned: boolean;
  note: string | null;
  fixedReportStatus: '済' | '未送信';
  fixedReportId: number | null;
}

export interface DailyVesselsDto {
  date: string;
  area: PortalArea;
  vessels: DailyVesselDto[];
  futureVessels: DailyVesselDto[];
  operatorCounts: { businessOperatorId: number | null; businessOperatorName: string; count: number }[];
  zoneCounts: { zoneNo: number; count: number; vesselIds: number[] }[];
}

export const portalKeys = {
  all: ['portal'] as const,
  summary: (year: number) => [...portalKeys.all, 'summary', year] as const,
  daily: (year: number, date: string, area: PortalArea) => [...portalKeys.all, 'daily', year, date, area] as const,
};

export function usePortalSummaryQuery(year: number) {
  return useQuery({
    queryKey: portalKeys.summary(year),
    queryFn: ({ signal }) => api.get<PortalSummaryDto>('/portal/summary', { fiscalYear: year }, { signal }),
  });
}

export function useDailyVessels(year: number, date: string, area: PortalArea) {
  return useQuery({
    queryKey: portalKeys.daily(year, date, area),
    queryFn: ({ signal }) => api.get<DailyVesselsDto>('/portal/daily-vessels', { fiscalYear: year, date, area }, { signal }),
    placeholderData: keepPreviousData,
  });
}
